var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 34,
    viewBox: "0 0 25 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0457 13.053C25.6198 15.0548 25.6198 18.9452 23.0457 20.947L8.34971 32.3754C5.06537 34.9295 0.280308 32.589 0.280308 28.4284L0.280308 5.57158C0.280308 1.41101 5.06536 -0.92951 8.34971 1.62458L23.0457 13.053Z",
    fill: "url(#paint0_linear_4_12)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_12",
    x1: 28.1212,
    y1: 17,
    x2: -9,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon8);
export default __webpack_public_path__ + "static/media/Polygon 8.0c757bd128f7f98e5afa562bf7121ba1.svg";
export { ForwardRef as ReactComponent };